var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
  }, [_vm._m(0), _vm._v(" "), _c('illustration', {
    staticClass: "hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72",
    attrs: {
      "name": "Group189"
    }
  })], 1), _vm._v(" "), _vm.allowed ? _c('div', [_c('div', {
    staticClass: "flex flex-col mt-16 mb-16"
  }, [_c('div', {
    staticClass: "-my-2 py-2"
  }, [_c('message-header', {
    attrs: {
      "message-header": _vm.messageHeader
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "relative min-w-full align-middle shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
  }, [_c('h3', {
    staticClass: "mt-15 mb-10 lg:mb-15 w-full"
  }, [_vm._v("\n            Gestion, droits et restrictions\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center items-center"
  }, [_c('nav', {
    staticClass: "flex justify-between md:justify-center md:space-x-10 text-gray-600 cursor-pointer text-center overflow-x-auto w-2/3 md:w-full"
  }, [_vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_ROLE_LISTE) ? _c('router-link', {
    staticClass: "flex-shrink-0 text-2xl inline-block hover:text-pink-600 font-light",
    class: {
      'text-indigo-600 font-normal': _vm.tabDisplay == 'PermissionsRoles'
    },
    attrs: {
      "to": {
        name: 'PermissionsRoles'
      }
    }
  }, [_vm._v("\n                Gestion des rôles\n              ")]) : _vm._e(), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_REFERENT_LISTE) ? _c('router-link', {
    staticClass: "flex-shrink-0 text-2xl inline-block pl-4 md:pl-0 hover:text-pink-600 font-light",
    class: {
      'text-indigo-600 font-normal': _vm.tabDisplay == 'PermissionsReferents' || _vm.tabDisplay == 'referentBeneficiaries' || _vm.tabDisplay == 'PermissionsBeneficiariesReferent'
    },
    attrs: {
      "to": {
        name: 'PermissionsReferents'
      }
    }
  }, [_vm._v("\n                Gestion des référents\n              ")]) : _vm._e(), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_LISTE) ? _c('router-link', {
    staticClass: "flex-shrink-0 text-2xl inline-block hover:text-pink-600 font-light pl-4 md:pl-0",
    class: {
      'text-indigo-600 font-normal': _vm.tabDisplay == 'PermissionsBeneficiaries'
    },
    attrs: {
      "to": {
        name: 'PermissionsBeneficiaries'
      }
    }
  }, [_vm._v("\n                Droits des bénéficiaires\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('icon', {
    staticClass: "ml-3 text-indigo-600 md:hidden block",
    attrs: {
      "name": "arrow-right_1"
    }
  })], 1), _vm._v(" "), _c('router-view')], 1)], 1)])]) : _c('page-not-allowed')], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "px-12"
  }, [_c('p', {
    staticClass: "text-4xl text-gray-900"
  }, [_vm._v("\n        Gestion, droits et restrictions\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 xl:pr-72"
  }, [_vm._v("\n        Espace de contrôle de tous les accès à vos Neopass afin d’assurer une\n        utilisation sécurisée et confidentielle pour toutes les personnes\n        internes ou externes à votre structure.\n      ")])]);

}]

export { render, staticRenderFns }